export default __webpack_public_path__ + "static/media/help-hero.9937f5bc.svg";